import { defaultCache } from "@serwist/turbopack/worker"
import { Serwist } from "serwist"


const serwist = new Serwist({
    precacheEntries: self.__SW_MANIFEST,
    // NOTE: MUST stay false so that a new service worker enters the `waiting`
    // state and `components/refresh-pop-up.js` can prompt the user to reload.
    skipWaiting: false,
    clientsClaim: true,
    navigationPreload: true,
    runtimeCaching: defaultCache,
})

serwist.addEventListeners()
